import axios from "axios";
import BASE_URL from "../../config";

// Get the auth token from localStorage and return headers
const getAuthHeader = () => {
  const tokenData = JSON.parse(localStorage.getItem("authUser") || "{}");
  return {
    Authorization: `Bearer ${tokenData.accessToken}`,
    'Content-Type': 'application/json'
  };
};

// API to fetch customers with optional filters
export const getCustomers = async (filter = {}) => {
  try {
    const response = await axios.post(`${BASE_URL}/api/Customer/get`, filter, {
      headers: getAuthHeader(),
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching customers:", error);
    throw error;
  }
};

// API to search customers with pagination and search text
export const searchCustomers = async (searchText, page = 1, pageSize = 20) => {
  try {
    console.log('🌐 API Call - searchCustomers:', {
      url: `${BASE_URL}/api/Customer/search`,
      payload: { searchText, page, pageSize, activeOnly: true },
      headers: getAuthHeader()
    });

    const response = await axios.post(`${BASE_URL}/api/Customer/search`, {
      searchText: searchText,
      page: page,
      pageSize: pageSize,
      activeOnly: true
    }, {
      headers: getAuthHeader(),
    });

    console.log('🌐 API Response - searchCustomers:', response.data);
    return response.data;
  } catch (error) {
    console.error("❌ API Error - searchCustomers:", error);
    console.error("❌ Error details:", {
      message: error.message,
      status: error.response?.status,
      statusText: error.response?.statusText,
      data: error.response?.data
    });
    throw error;
  }
};

// API to insert or update a customer
export const saveCustomer = async (customerData) => {
  try {
    console.log("API call - saveCustomer:", customerData);
    const response = await axios.post(`${BASE_URL}/api/Customer/save`, customerData, {
      headers: getAuthHeader(),
    });
    console.log("API response - saveCustomer:", response.data);
    return response.data;
  } catch (error) {
    console.error("API error - saveCustomer:", error);
    // If it's a validation error (400), return the error response data so it can be handled gracefully
    if (error.response && error.response.status === 400) {
      // Return the error response data so the calling code can check id and message
      return error.response.data;
    }
    throw error;
  }
};

// API to bulk import customers
export const bulkImportCustomers = async (customersData) => {
  try {
    console.log("API call - bulkImportCustomers:", customersData.length, "customers");
    const response = await axios.post(`${BASE_URL}/api/Customer/bulk-import`, customersData, {
      headers: getAuthHeader(),
    });
    console.log("API response - bulkImportCustomers:", response.data);
    return response.data;
  } catch (error) {
    console.error("API error - bulkImportCustomers:", error);
    throw error;
  }
};

export const exportCustomersToExcel = async (filter = {}) => {
  try {
    const response = await axios.post(`${BASE_URL}/api/Customer/export-excel`, filter, {
      headers: getAuthHeader(),
      responseType: 'blob'
    });

    // Create download link
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `CustomerReport_${new Date().toISOString().slice(0, 19).replace(/[-:]/g, '').replace('T', '_')}.xlsx`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);

    return true;
  } catch (error) {
    console.error("Error exporting customers:", error);
    throw error;
  }
};

// API to advanced search customers with multiple filters and pagination
export const advancedSearchCustomers = async (filters, page = 1, pageSize = 10, userBranchId = null) => {
  try {
    const requestBody = {
      Page: page,
      PageSize: pageSize,
      Customer_NameEn: filters.customer_NameEn || null,
      Customer_NameAr: filters.customer_NameAr || null,
      Customer_ContactNo: filters.customer_ContactNo || null,
      Customer_Country_Id: filters.customer_Country_Id || null,
      Customer_Email: filters.customer_Email || null,
      Customer_Code: filters.customer_Code || null,
      Customer_ID_Number: filters.customer_ID_Number || null,
      Customer_TRN: filters.customer_TRN || null,
      Company_Name: filters.company_Name || null,
      PrimaryContact_Name: filters.primaryContact_Name || null,
      PrimaryContact_Phone: filters.primaryContact_Phone || null,
      Customer_Type: filters.customer_Type || null,
      Customer_Branch_Id: filters.customer_Branch_Id || null,
      Customer_Active: filters.customer_Active !== undefined ? filters.customer_Active : true, // Default to active only
      Customer_IsInternational: filters.customer_IsInternational !== undefined ? filters.customer_IsInternational : null,
      User_Branch_Id: userBranchId || null
    };

    const response = await axios.post(`${BASE_URL}/api/Customer/advanced-search`, requestBody, {
      headers: getAuthHeader(),
    });

    return response.data;
  } catch (error) {
    console.error("❌ API Error - advancedSearchCustomers:", error);
    throw error;
  }
};
